import { CircularProgress, Typography } from '@mui/material'
import React from 'react'
import { RequestNextApi } from '../../../../api/Request'
import { getCookie } from '../../../../utils/cookieHandle'
import { ShowNotification } from '../../../../utils/notification/snackbarUtils'


const downloadFile = (blob, filename) => {
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}

const SingleExport = ({ template }) => {
    const [loading, setLoading] = React.useState(false)

    const onRunExport = async (template) => {
        try {
            setLoading(true)
            const result = await RequestNextApi.post('/admin/export/run-export-query',
                {
                    jwtToken: getCookie('jwt-token'),
                    template_id: template.id,
                    response_type: "csv"
                }
            );
            if (result.data.success) {
                const blob = new Blob([result.data.data], { type: "text/csv" });
                downloadFile(blob, (template.template_name || "export").replace(" Query", "") + ".csv")
            } else {
                ShowNotification.error(result.data.message);
            }
        } catch (e) {

        } finally {
            setLoading(false)
        }
    }
    return (
        <div className='flex gap-2 items-center w-fit'>
            <Typography
                variant='body2'
                className='font-normal cursor-pointer'
                onClick={() => {
                    if (!loading) {
                        onRunExport(template)
                    }
                }}>
                <span className='underline'>{template.template_name}</span> {loading &&
                    <CircularProgress
                        onClick={
                            (e) => {
                                e.stopPropagation()
                            }
                        }
                        className='ml-2'
                        size={10}
                    />}
            </Typography>
        </div>
    )
}

const ExportCategory = ({ templates, categoryName }) => {
    if (!templates.length) {
        return null
    }
    return (
        <div className='border-[1px] border-solid border-primary-100 rounded-xl p-[20px]'>
            <Typography variant='h4' className='font-normal'>
                {categoryName}
            </Typography>
            <div className='mt-2 flex flex-col gap-y-[5px]'>
                {templates.map((template, index) => <SingleExport key={index} template={template} />)}
            </div>

        </div>
    )
}

function StaffExports() {
    const [categories, setCategories] = React.useState([])
    const [templatesOfCategories, setTemplatesOfCategories] = React.useState({})
    const [loading, setLoading] = React.useState(false)

    React.useEffect(() => {
        const fetchExports = async () => {
            try {
                setLoading(true)
                const result = await RequestNextApi.post('/admin/export/fetch-export-categories',
                    {
                        jwtToken: getCookie('jwt-token'),
                    }
                );
                if (result.data.success) {
                    const res = await RequestNextApi.post('/admin/export/fetch-export-queries',
                        {
                            jwtToken: getCookie('jwt-token'),
                        }
                    );
                    if (res.data.success) {
                        const _templatesOfCategories = res.data.export_templates.reduce((acc, template) => {
                            if (template.category_id === 12) {
                                return acc;
                            }
                            if (acc[template.category_id]) {
                                acc[template.category_id].push(template)
                            } else {
                                acc[template.category_id] = [template]
                            }
                            return acc

                        }, {});
                        setCategories(result.data.export_categories)
                        setTemplatesOfCategories(_templatesOfCategories)
                    } else {
                        ShowNotification.error(result.data.message);
                    }
                } else {
                    ShowNotification.error(result.data.message);
                }
            } catch (e) {
                ShowNotification.error("Failed to load the export templates!");
            } finally {
                setLoading(false)
            }
        }
        fetchExports()
    }, [])

    if (loading) {
        return <div className=''>
            <div className='mt-6'>
                <CircularProgress color="secondary" size={20} />
            </div>
        </div>
    }

    return (
        <div className='flex flex-col mt-6 gap-y-6'>
            {
                categories.map((category, index) => {
                    return <ExportCategory categoryName={category.category} templates={templatesOfCategories?.[category.id] || []} key={index} />
                })
            }
        </div>
    )
}

export default StaffExports